import {ParseGidError} from './errors';

/**
 * true when the event is 'Added Product' from core/shop_events_listener.js
 * For more details check:
 * https://github.com/Shopify/shopify/blob/01424c4cd97aa4477395653559550fae0a0d4c6b/app/assets/javascripts/shop_events_listener.js#L95
 */
export function isStorefrontAddedProduct(eventName: string) {
  return eventName === 'Added Product';
}

/**
 * true when the event is 'spb_checkout_created' from payment-sheet/CheckoutProcessorProvider.tsx
 * This event is fired when the user clicks the "Buy Now" button with the exception of the default Checkout Instrument.
 * For more details check:
 * https://github.com/Shopify/payment-sheet/blob/ee03a2744427ff31577492ba9ab249fb9587e221/src/components/CheckoutProcessor/CheckoutProcessorProvider.tsx#L361
 */
export function isCheckoutCreated(eventName: string) {
  return eventName === 'spb_checkout_created';
}

export function isThemeEditor() {
  return window.Shopify?.designMode || Boolean(window.Shopify?.editorDomain);
}

export function debounce(func: (...args: any[]) => any, timeout = 40) {
  let timer: NodeJS.Timeout;

  return (...args: any[]) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply({}, args);
    }, timeout);
  };
}

export function parseGid(gid: string): string {
  // prepends forward slash to help identify invalid id
  const url = new URL(gid);
  const id = url.pathname.split('/').pop();

  if (id) return id;

  throw new ParseGidError(`Invalid gid: ${gid}`);
}
